import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { get } from "lodash";

import Close from "@material-ui/icons/Close";
import { I18n } from "@aws-amplify/core";

const styles = {
  selectPrinter: {
    width: "400px",
    minHeight: "230px",
    padding: "24px",
    display: "flex",
    
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    fontSize: "14px",
    boxSizing: "border-box",
  },
  selectPrinterNav: {
    width: "100%",
    height: "24px",
    display: "grid",
    gridTemplateColumns: "1fr 24px",
    placeItems: "center",
    marginBottom: "40px",
  },

  interactPanel: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "center",

  },
  selectPrinterTitle: {
    display: "flex",
    alignItems: "center",
    // fontSize: "14px",

    "& div": {
      marginLeft: "8px",
    }
  },

  closeButton: {
    justifySelf: "end",
    alignSelf: "center",
    width: "24px",
    height: "24px",

    "&:hover": {
      backgroundColor: "#f2f9fa",
      borderRadius: "2px",
      cursor: "pointer",
    }
  },

  buttonContainer: {
    marginTop: "40px",
    display: "flex",
    justifyContent: "space-between",
  },

  confirmBtn: {
    width: "122px",
    height: "36px",
    backgroundColor: "#5f00a0",
    borderRadius: "2px",
    border: "none",
    color: "white",
    marginLeft: "24px"
  },

  cancelBtn: {
    width: "122px",
    height: "36px",
    backgroundColor: "white",
    borderRadius: "2px",
    border: "none",
    color: "#5f00a0",
    fontWeight: "500",
  },
};
  
const PrinterSelection = (props) => {
  const { classes, devices, labelWidth } = props;

  const [value, setValue] = React.useState(devices[0].uid);

  const handlePrinterSelection = () => {
    // need a new way to activate.... humm function call?
    props.setOpenSelectPrinter(false);
    props.updatePrinterWidthConfig(value);
  }

  let optionList=[];
  devices.forEach((device)=>{
    optionList.push( <option value={device.uid}>{device.name}</option> )
  })
  
  return (
    <div className={classes.selectPrinter}>
      <div className={classes.selectPrinterNav}>
        <div className={classes.selectPrinterTitle}>
          <div>{I18n.get("label_printer_selection").toUpperCase()}</div>
        </div>
        <div className={classes.closeButton}>
          <Close onClick={() => props.setOpenSelectPrinter(false)}/>
        </div>
      </div>

      <div className={classes.interactPanel}>
        <span className={classes.printerQuestion}>{I18n.get("label_which_printer") + labelWidth + I18n.get("label_which_printer_2")}</span><br />
        <select className={classes.printerOption} name="label_printers" id="label_printers" onChange={(e) => { setValue(e.target.value) }} value={value}>
            {optionList}
        </select>
      </div>

      <div className={classes.buttonContainer}>
        <button 
          className={classes.cancelBtn} 
          type="button" 
          onClick={() => props.setOpenSelectPrinter(false)}>{I18n.get("site_cancel").toUpperCase()}</button>

        <button 
          className={classes.confirmBtn} 
          type="button" 
          onClick={() => handlePrinterSelection()}>{I18n.get("site_confirm").toUpperCase()}</button>

      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(PrinterSelection))
);  